'use client';
import React from 'react';
import Image from 'next/image';
import { JobDetail } from '~/types/job-detail';

interface JobImagesProps {
  job: JobDetail;
  isMobile: boolean;
}

export function JobImages({ job, isMobile }: JobImagesProps) {
  const containerClassName = `u-px16 ${!isMobile ? 'u-py40' : 'u-mb4'}`;

  return (
    <div className={containerClassName}>
      <div className="p-job_images">
        {job.media_info.images_additional.map((theImage, i) => {
          const imageUrl = theImage.thumb?.file?.exists
            ? theImage.thumb.url || theImage.url
            : theImage.url;

          return (
            <Image
              key={i}
              src={imageUrl}
              alt="求人詳細の画像"
              width={280}
              height={186}
              loading="lazy"
              className="p-job_images__image"
              unoptimized
            />
          );
        })}
      </div>
    </div>
  );
}
